import { useState } from 'react';

const faqs = [
  {
    q: 'Premium planı nasıl satın alabilirim?',
    a: 'Hesabınıza giriş yapın, Premium sayfasına gidin ve istediğiniz planı seçin. Kredi kartı veya debit kart ile güvenli ödeme yapabilirsiniz.',
  },
  {
    q: 'İstediğim zaman iptal edebilir miyim?',
    a: 'Evet, aboneliğinizi istediğiniz zaman hiçbir ceza ödemeden iptal edebilirsiniz. İptal ettiğinizde mevcut dönem sonuna kadar Premium özelliklerinden yararlanmaya devam edersiniz.',
  },
  {
    q: 'Yıllık ve aylık plan arasındaki fark nedir?',
    a: 'Yıllık planda aylık plana göre %30 daha ucuza aynı özelliklere sahip olursunuz. Yıllık plan tek seferde ön ödeme ile faturalandırılır.',
  },
  {
    q: 'Cinsiyet filtresi gerçekten çalışıyor mu?',
    a: 'Evet. Cinsiyet filtresi yalnızca Premium üyelere açık bir özelliktir. Filtrenizi etkinleştirdiğinizde sistem sizi yalnızca tercih ettiğiniz cinsiyetten kullanıcılarla eşleştirir.',
  },
  {
    q: '"Yeniden Bağlan" özelliği nasıl çalışır?',
    a: 'Bağlantı istemeden kesildiğinde veya eşleştiğiniz kişi ayrılmadan önce "Yeniden Bağlan" butonuna basarsanız, aynı kişiyle tekrar eşleştirilmeye çalışılırsınız. Bu özellik yalnızca Premium kullanıcılara açıktır.',
  },
  {
    q: 'Para iade garantisi var mı?',
    a: 'Satın alma tarihinden itibaren 7 gün içinde herhangi bir sebep göstermeksizin tam iade talep edebilirsiniz. Destek ekibimizle iletişime geçmeniz yeterli.',
  },
  {
    q: 'Ücretsiz planla Premium arasındaki en büyük fark nedir?',
    a: 'Ücretsiz planda rastgele eşleşme yapılır ve reklamlar gösterilir. Premium ile cinsiyet/ülke filtreleri, reklamsız deneyim, öncelikli eşleşme ve HD video kalitesine erişirsiniz.',
  },
];

const PremiumFAQ = () => {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="py-16 md:py-20 bg-[#060810]">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/5 border border-white/10 text-white/50 text-xs font-semibold mb-5">
            <i className="ri-question-line" />
            Sık Sorulan Sorular
          </div>
          <h2 className="text-2xl md:text-4xl font-extrabold text-white mb-3">
            Aklında mı Takıldı?
          </h2>
          <p className="text-white/40 text-sm md:text-base">
            Premium hakkında en çok sorulan sorular.
          </p>
        </div>

        {/* Accordion */}
        <div className="flex flex-col gap-3">
          {faqs.map((faq, i) => {
            const isOpen = open === i;
            return (
              <div
                key={i}
                className={`rounded-2xl border transition-all duration-300 overflow-hidden ${
                  isOpen
                    ? 'bg-yellow-500/5 border-yellow-500/25'
                    : 'bg-white/3 border-white/8 hover:border-white/15'
                }`}
              >
                <button
                  onClick={() => setOpen(isOpen ? null : i)}
                  className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left cursor-pointer"
                >
                  <span className={`font-semibold text-sm md:text-base leading-snug transition-colors ${isOpen ? 'text-white' : 'text-white/70'}`}>
                    {faq.q}
                  </span>
                  <div
                    className={`w-7 h-7 flex items-center justify-center rounded-full flex-shrink-0 transition-all duration-300 ${
                      isOpen
                        ? 'bg-yellow-500/20 text-yellow-400 rotate-45'
                        : 'bg-white/6 text-white/30'
                    }`}
                  >
                    <i className="ri-add-line text-sm" />
                  </div>
                </button>

                {/* Answer */}
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    isOpen ? 'max-h-48 opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <p className="px-6 pb-5 text-white/50 text-sm leading-relaxed">
                    {faq.a}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        {/* Support link */}
        <div className="text-center mt-10">
          <p className="text-white/35 text-sm">
            Aradığın cevabı bulamadın mı?{' '}
            <a href="/help" className="text-yellow-400 hover:text-yellow-300 transition-colors cursor-pointer font-medium">
              Destek merkezine git →
            </a>
          </p>
        </div>
      </div>
    </section>
  );
};

export default PremiumFAQ;
